import * as React from "react";

function TrashDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.5 3.036H10v-.621a1.445 1.445 0 00-1.5-1.379h-1A1.445 1.445 0 006 2.415v.621H2.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H3v7.5a1.5 1.5 0 001.5 1.5h7a1.5 1.5 0 001.5-1.5v-7.5h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM7 2.415c0-.205.229-.379.5-.379h1c.271 0 .5.174.5.379v.621H7v-.621zm5 11.121a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7.5h8v7.5zm1-8.5H3v-1h10v1zm-6.5 7.5h-1v-5h1v5zm4-.015h-1V7.536h1v4.985zm-2 0h-1V7.536h1v4.985z"
  }));
}

export default TrashDeleteIcon;